
export default {
  methods: {
    generateSearchData: function(props) {
      const filter = this.$store.getters.getFilter;
      const data = {};
      for (let prop of props) {
        if (typeof prop === 'object') {
          if (filter) {
            data[prop.name] = this.$route.query[prop.name] || prop.value;
          } else {
            data[prop.name] = this.$route.query[prop.name] || '';
          }
          continue;
        }
        data[prop] = this.$route.query[prop] || '';
      }
      // In order to prevent from reflecting changes directly in URL,
      // Create a copy of the searchData in data so it can be binded
      data['searchData'] = { ...data };
      return data;
    }
  }
};
